﻿window.onSubmitCallRegistration = function(token) {
        console.log("onSubmit called!")
        //var ajaxForm = $('#mainform');

        //console.log("onSubmit calling Ajax!")
        //// Perform the Ajax post to the server
        //$.ajax({
        //    type: 'POST',
        //    url: '/api/sitecore/CallRegistration/GetContent?Length=16',
        //    data: ajaxForm.serialize(),
        //    success: function (result) {
        //        // Handle the successful server response
        //        $('#mainform').hide();
        //        $('#registerThanks').show();
        //        console.log("onSubmit Ajax success!")
        //        console.log(result);
        //    },
        //    error: function (jqXHR, textStatus, errorThrown) {
        //        // Handle the server error response
        //        console.log("onSubmit Ajax error!")
        //        console.log(errorThrown);
        //        $('#registerThanks').hide();
        //    }
        //});  
}